<script lang="ts" module>
  import { tv } from 'tailwind-variants';

  export interface ConfigMenuBtnProps {
    active?: boolean;
    onChange?: (active: boolean) => void;
  }

  const styles = tv({
    base: 'fc-cc rounded-sm p-1 transition-colors duration-300',
    variants: {
      active: {
        true: 'bg-btn-sec hocus:bg-btn-tert-H',
        false: 'bg-plain hover:bg-btn-sec-H',
      },
    },
  });
</script>

<script lang="ts">
  import { Icon } from '@/ui/base';

  let props: ConfigMenuBtnProps = $props();
  let active = $state(!!props.active);
  $effect(() => {
    active = !!props.active;
  });
  let cn = $derived(styles({ active }));
  let handleChange = () => {
    active = !active;
    props.onChange?.(active);
  };
  let label = $derived(active ? 'Konfiguration übernehmen' : 'Konfigurationen öffnen');
</script>

<button class={cn} onclick={handleChange} aria-label={label}>
  <Icon icon={active ? 'Done' : 'Tune'} class="pointer-events-none" size={5} />
</button>
